// extracted by mini-css-extract-plugin
module.exports = {"summary":"Greeting_summary__EL0mI"};